export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10800.6b4c2a54.jpg";